import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import {
  Accordion as MuiExpansionPanel,
  AccordionDetails as MuiExpansionPanelDetails,
  AccordionSummary as MuiExpansionPanelSummary,
  withStyles,
} from '@material-ui/core';

import { ExpandMore as MuiExpandMoreIcon } from '@material-ui/icons';

import {
  ExpansionPanelDetailsStyles,
  ExpansionPanelStyles,
  ExpansionPanelSummaryStyles,
} from './ExpandablePanelStyles';


const propTypes = {
  children: PropTypes.node,
  labelComponent: PropTypes.func,
  expanded: PropTypes.bool.isRequired,
  expandPanel: PropTypes.func.isRequired,
  label: PropTypes.string,
  expandedAriaLabel: PropTypes.string,
  collapsedAriaLabel: PropTypes.string,
  description: PropTypes.string,
};

const defaultProps = {
  labelComponent: noop,
  description: null,
  label: null,
  expandedAriaLabel: undefined,
  collapsedAriaLabel: undefined,
  children: null,
};


const StyledExpansionPanelDetails = withStyles(
  ExpansionPanelDetailsStyles,
)(MuiExpansionPanelDetails);

const StyledExpansionPanel = withStyles(
  ExpansionPanelStyles,
)(MuiExpansionPanel);

const StyledExpansionPanelSummary = withStyles(
  ExpansionPanelSummaryStyles,
)(MuiExpansionPanelSummary);


const ExpandablePanel = ({ expanded, expandPanel, labelComponent, label, expandedAriaLabel, collapsedAriaLabel, description, children }) => (
  <StyledExpansionPanel
    square
    expanded={ expanded }
    onChange={ expandPanel }
  >
    <StyledExpansionPanelSummary
      expandIcon={ <MuiExpandMoreIcon /> }
      aria-label={ expanded ? expandedAriaLabel : collapsedAriaLabel }
    >
      { labelComponent
        ? labelComponent()
        : (
          <Fragment>
            <span>{ label }</span>
            <span>{ description }</span>
          </Fragment>
        )
      }
    </StyledExpansionPanelSummary>
    <StyledExpansionPanelDetails>
      { children }
    </StyledExpansionPanelDetails>
  </StyledExpansionPanel>
);

ExpandablePanel.propTypes = propTypes;
ExpandablePanel.defaultProps = defaultProps;

export default ExpandablePanel;
